var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-progress',_vm._b({attrs:{"percentage":_vm.getPercentage}},'el-progress',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }